import React from "react";
import { FaLinkedinIn, FaMedium, FaGithub } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Shravan Bobade</h3>
        <p className="text-lg font-normal text-gray-400">
          Full Stack Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Hi, I'm Shravan Bobade when I'm not staring at a screen wondering why
          my code works (or doesn't), I'm probably fixing one issue just to
          create another. If you enjoy debugging, caffeine, or just a good tech
          rant—let's connect and trade some war stories!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 7776000344</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email:{" "}
          <span className="text-lightText">shravan.bobade.tech@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a className="bannerIcon" href="https://github.com/Shravan250">
            <FaGithub />
          </a>
          <a
            className="bannerIcon"
            href="https://medium.com/@shravan.bobade.tech"
          >
            <FaMedium />
          </a>
          <a className="bannerIcon" href="www.linkedin.com/in/shravan-bobade">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
